export default "__VITE_ASSET__C8Mi4PSk__"